// Storefront filters shared by the home page and All products.
// API values: gender 1 = boys, 2 = girls, 3 = everyone; age 0 = any, 1..7 = "(n-1)-n years".
export const GENDERS = [
    { value: '3', key: 'all', label: 'Everyone' },
    { value: '2', key: 'girls', label: 'Girls' },
    { value: '1', key: 'boys', label: 'Boys' }
]

export const AGES = [
    { value: '0', label: 'All ages' },
    { value: '1', label: '0–1 yr' },
    { value: '2', label: '1–2 yrs' },
    { value: '3', label: '2–3 yrs' },
    { value: '4', label: '3–4 yrs' },
    { value: '5', label: '4–5 yrs' },
    { value: '6', label: '5–6 yrs' },
    { value: '7', label: '6–7 yrs' }
]

// Link to a filtered All products view, e.g. allItemsLink({ for: 'girls' }) or allItemsLink({ age: '2' }).
export const allItemsLink = (filters = {}) => {
    const q = new URLSearchParams()
    if (filters.for && filters.for !== 'all') q.set('for', filters.for)
    if (filters.age && filters.age !== '0') q.set('age', filters.age)
    return '/items/all' + (q.toString() ? '?' + q.toString() : '')
}
